import { Icons } from '@Components/icon/Icon.tsx';
import { getFormFieldsModel } from './error.service.ts';
import type { StateCreator } from 'zustand';
import type { IErrorModalProps, IErrorSlice } from '@Types/index.ts';
import type { REVIEW_BLOCK_TYPES } from '@Pages/happyFlowPages/reviewPage/types';

export const createErrorSlice: StateCreator<IErrorSlice> = (set, get) => ({
  errorSlice: {
    errorModal: {
      error: '',
      modalProps: {
        title: '',
        content: '',
        icon: Icons.Oops,
        buttonText: '',
        type: undefined,
        onSubmit: () => {},
      },
    },
    isNameTooLongModalShown: false,
    reviewBlockErrors: {},
    setErrorModal: (data: { error: string; modalProps?: IErrorModalProps }) =>
      set({
        errorSlice: {
          ...get().errorSlice,
          errorModal: data,
        },
      }),
    setIsNameTooLongModalShown: (isShown: boolean) =>
      set({
        errorSlice: {
          ...get().errorSlice,
          isNameTooLongModalShown: isShown,
        },
      }),
    formFieldErrors: getFormFieldsModel(),
    setFormFieldError: (field, error) =>
      set({
        errorSlice: {
          ...get().errorSlice,
          formFieldErrors: {
            ...get().errorSlice.formFieldErrors,
            [field]: error,
          },
        },
      }),
    resetFormFieldErrors: () =>
      set({
        errorSlice: {
          ...get().errorSlice,
          formFieldErrors: getFormFieldsModel(),
        },
      }),
    setReviewBlockError: (blockType: REVIEW_BLOCK_TYPES, message?: string) =>
      set({
        errorSlice: {
          ...get().errorSlice,
          reviewBlockErrors: {
            ...get().errorSlice.reviewBlockErrors,
            [blockType]: { hasError: true, message },
          },
        },
      }),
    clearReviewBlockError: (blockType: REVIEW_BLOCK_TYPES) =>
      set({
        errorSlice: {
          ...get().errorSlice,
          reviewBlockErrors: {
            ...get().errorSlice.reviewBlockErrors,
            [blockType]: undefined,
          },
        },
      }),
    resetReviewBlockErrors: () =>
      set({
        errorSlice: {
          ...get().errorSlice,
          reviewBlockErrors: {},
        },
      }),
  },
});
